import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleModalDiagramRestore, diagramRestore } from '../../../redux/main/main.actions';
import { selectIsModalDiagramRestoreEnabled, selectModalDiagramRestoreData } from '../../../redux/main/main.selectors';

import Modal from '../Modal/Modal';
import './ModalDiagramRestore.scss';

export const ModalDiagramRestore = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalDiagramRestoreEnabled);
    const modalData = useSelector(selectModalDiagramRestoreData);

    const [value, setValue] = useState(modalData?.diagram?.title || '');

    useEffect(() => {
        if (!modalData?.diagram?.title) return;

        if (value !== modalData?.diagram?.title) {
            setValue(modalData?.diagram?.title || '');
        }
        return () => { };
    }, [modalData]);

    const handleSave = () => {
        dispatch(diagramRestore(modalData?.diagram?.id));
        dispatch(toggleModalDiagramRestore(null));
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramRestore(null));
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-restore`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{`Restore diagram`}</div>
            <div className="modal-content-body">
                <div className='description-text'>{`This will restore `}<span className='text-title-bold'>{value}</span>.</div>
                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>Cancel</button>
                    <button onClick={() => handleSave()}>Restore</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramRestore;
